import design from '@STYLES/exports/design.module.scss';

import extractCSSVars from './helpers/extractCSSVars';

const DESIGN = extractCSSVars<number>(design, (a) => +a) as Readonly<Constant.Design>;

export default DESIGN;
